import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSdCard: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconSdCard"><Path fillRule="evenodd" clipRule="evenodd" d="M4 2V22H20V10.6972L18 7.69722V2H4ZM10 6V10H8V6H10ZM14 6H12V10H14V6Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSdCard;
